// src/utils/apiFetch.ts
import { getIdTokenFromCookie } from "./getIdToken";
import { API_URL } from "./runtimeConfig";

export async function apiFetch(path: string, options: RequestInit = {}) {
  const token = getIdTokenFromCookie();

  const headers: Record<string, string> = {
    ...(options.headers as any),
    ...(token ? { authorization: `Bearer ${token}` } : {}),
  };

  return fetch(`${API_URL}${path}`, { ...options, headers });
}
